<template>
  <div class="tabs-wrap">
    <div
      v-for="tab in items"
      :key="tab.id"
      @click="clickHandler(tab.id)"
      @mouseenter="mouseEnterHandler(tab.id)"
    >
      <SingleTab
        :tab="tab"
        :dropdown-for-tab="dropdownForTab"
        :tab-click-count="dropdownTabClickCount"
        @click-dropdown-item="handleClickDropdownItem"
      >
        <slot />
      </SingleTab>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Tab } from '@/types/tabs';
import SingleTab from '@/components/widgets/SingleTab';
import { onMounted, ref } from 'vue';

const props = defineProps<{ items: Tab[]; dropdownForTab?: string }>();

const dropdownTabClickCount = ref(0);

const emit = defineEmits(['click', 'mouseenter']);

const isTabSelected = (tabId: string) => {
  return props.items.find((t) => t.id === tabId)?.selected;
};

const clickHandler = (tabId: string) => {
  dropdownTabClickCount.value =
    tabId === props.dropdownForTab ? dropdownTabClickCount.value + 1 : 0;

  if (isTabSelected(tabId)) return;
  emit('click', tabId);
};

const mouseEnterHandler = (tabId: string) => {
  emit('mouseenter', tabId);
};

const handleClickDropdownItem = () => (dropdownTabClickCount.value = 1);

onMounted(() => {
  /**
   * If the dropdown tab is already selected, set click count to 1,
   * otherwise clear it out
   */
  const selectedTab = (props?.items || []).find((t) => t.selected);
  dropdownTabClickCount.value = Number(selectedTab?.id === props.dropdownForTab);
});
</script>

<style lang="scss">
.tabs-wrap {
  @apply flex flex-row h-6 box-border border border-solid border-important-border rounded overflow-hidden;
  @apply divide-solid divide-x divide-important-border divide-y-0;
}
</style>
